import { Navigate, useNavigate } from 'react-router-dom';

import { Button } from '../ui/Button';
import { logout } from '../store/slices/auth';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { selectUser, selectUserHydrated } from '../store/selectors/auth';

/**
 * Hiding a nav item is not access control: a typed URL would otherwise mount the
 * page and fire authorization failures at every endpoint it touches.
 *
 * Three states, not two. `user` is null both while /auth/me/ is in flight and when
 * it failed, so hydration completion is tracked separately - otherwise a failed
 * lookup leaves the guard pending forever with no way out.
 */
export const RoleRoute = ({ allow, children }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const user = useAppSelector(selectUser);
  const hydrated = useAppSelector(selectUserHydrated);

  if (!hydrated) {
    return <div className="p-6 text-sm text-gray-dark">Checking access…</div>;
  }

  if (!user) {
    return (
      <div className="flex flex-col items-start gap-3 p-6">
        <p className="text-base text-foreground">We couldn&apos;t confirm your access.</p>
        <p className="text-sm text-gray-dark">
          Your account details could not be loaded. Signing in again usually fixes it.
        </p>
        <Button
          variant="primary"
          onClick={() => {
            dispatch(logout());
            navigate('/login');
          }}
        >
          Sign in again
        </Button>
      </div>
    );
  }

  return allow(user) ? children : <Navigate to="/dashboard" replace />;
};
